// ============================================================================
// tasks.todo.detail — migrated off the global read
// ============================================================================
// /tasks/todo/<id>. Two obligations because the page has two genuinely
// different contracts: the list read is ungated and fails CLOSED, the
// assignable-profile read is manager-gated and fails SOFT. It shares
// tasks.todo.list with tasks.center and separates itself by the key: recordId
// is a key-only param, so an A -> B record navigation refetches exactly as the
// page's own effect does today.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'tasks.todo.detail',
  obligations: Object.freeze([
    Object.freeze({id: 'tasks.todo.list', owner: 'permanent'}),
    Object.freeze({id: 'tasks.assignable.profiles', owner: 'permanent'}),
    Object.freeze({id: 'tasks.todo.signedPhotoUrl', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
